// import i18n from '@/locale/index'

export default [
  {
    path: '/myVideo',
    name: 'myVideo',
    component: () => import('../../views/myVideo/index.vue'),
    meta: {
    //   title: i18n.global.t('points.c5')
      title: "myUnityVideo"
    }
  }
]